import { WardGroupType } from './ward-group-type.model';

export class WardGroup {
  campusWardGroupId: number;
  campusWardId: number;
  type: WardGroupType;
  name: string;
  active: boolean;

  constructor(campusWardId: number) {
    this.campusWardId = campusWardId;
    this.campusWardGroupId = 0;
    this.active = true;
  }
}
